import { useCallback } from 'react'

import { useMutation, useQueryClient } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'
import type { RestrictedWord } from '@/modules/restricted-words/types.ts'

export function useEditRestrictedWord() {
  const queryClient = useQueryClient()

  const editMutation = useMutation(
    (params: Partial<RestrictedWord>) =>
      restrictedWordsService.editRestrictedWord(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['restrictedWords'])
      },
    },
  )

  const editRestrictedWord = useCallback(
    (params: Partial<RestrictedWord>) => {
      return editMutation.mutateAsync(params)
    },
    [editMutation],
  )

  return {
    editRestrictedWord,
    isEditRestrictedWordLoading: editMutation.isLoading,
  }
}
